<template>
    <div class="container mt-3 mb-3">
        <div class="row">
            <div class="col-md-12">
                <div class="card p-3">
                    <h5 class="mb-3">Edit Repair #{{ form.id }} - <small class="text-muted">SN: {{ form.sn }}</small></h5>
                    <form @submit.prevent="submitUpdate">
                        <div class="row g-2">
                            <div class="col-md-4 mb-2">
                                <label class="form-label-compact">Technician / Employee</label>
                                <input type="text" class="form-control form-control-sm" v-model="form.tech" required />
                            </div>
                            <div class="col-md-4 mb-2">
                                <label class="form-label-compact">Job Name</label>
                                <input type="text" class="form-control form-control-sm" v-model="form.jobName" required />
                            </div>
                            <div class="col-md-4 mb-2">
                                <label class="form-label-compact">PO</label>
                                <input type="text" class="form-control form-control-sm" v-model="form.po" />
                            </div>
                            <div class="col-md-4 mb-2">
                                <label class="form-label-compact">Contact Name</label>
                                <input type="text" class="form-control form-control-sm" v-model="form.contactName" />
                            </div>
                            <div class="col-md-4 mb-2">
                                <label class="form-label-compact">Contact #</label>
                                <input type="text" v-mask="'###-###-####'" class="form-control form-control-sm" v-model="form.contactNumber" />
                            </div>
                            <div class="col-md-4 mb-2">
                                <label class="form-label-compact">Unit Description</label>
                                 <select v-model="form.unitDesc" class="form-control form-control-sm"
                                            required>
                                            <option value="12 Station M DC">12 Station M DC</option>
                                            <option value="24 Station M DC">24 Station M DC</option>
                                            <option value="12 Station M AC">12 Station M AC</option>
                                            <option value="24 Station M AC">24 Station M AC</option>
                                            <option value="ACE">ACE</option>
                                            <option value="Piccolo 1/1">Piccolo 1/1</option>
                                            <option value="Piccolo 2/2">Piccolo 2/2</option>
                                            <option value="Piccolo 4/4">Piccolo 4/4</option>
                                            <option value="XPR5350e">XPR5350e</option>
                                            <option value="CP200">CP200</option>
                                            <option value="n/a">n/a</option>
                                        </select>
                            </div>
                            <div class="col-md-6 mb-2">
                                <label class="form-label-compact">Reported Issue</label>
                                <textarea class="form-control form-control-sm" v-model="form.issueReported" rows="6"></textarea>
                            </div>
                            <div class="col-md-6 mb-2">
                                <label class="form-label-compact">Description of Work Done</label>
                                <textarea class="form-control form-control-sm" v-model="form.description" rows="6"></textarea>
                            </div>
                            <div class="col-md-3 mb-2 d-flex align-items-center justify-content-center">
                                <input type="checkbox" id="analogBoard" class="form-check-input me-2" v-model="form.analogBoard" :true-value="1" :false-value="0" />
                                <label for="analogBoard" class="form-label-compact mb-0">Analog Board</label>
                            </div>
                            <div class="col-md-9 mb-2">
                                <label class="form-label-compact mb-1">Status</label>
                                <div class="btn-group w-100 mb-2" role="group" aria-label="Status filter">
                                    <button
                                        type="button"
                                        class="btn"
                                        :class="{'btn-primary': form.status === 1, 'btn-outline-dark': form.status !== 1}"
                                        @click="form.status = 1"
                                    >
                                        🚀 Opened
                                    </button>
                                    <button
                                        type="button"
                                        class="btn"
                                        :class="{'btn-primary': form.status === 2, 'btn-outline-dark': form.status !== 2}"
                                        @click="form.status = 2"
                                    >
                                         🧰 In repair
                                    </button>
                                    <button
                                        type="button"
                                        class="btn"
                                        :class="{'btn-primary': form.status === 3, 'btn-outline-dark': form.status !== 3}"
                                        @click="form.status = 3"
                                    >
                                        ✅ Closed
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="text-end mt-3">
                            <button type="submit" class="btn btn-success btn-sm" :disabled="isUpdating">
                                Save Changes
                            </button>
                        </div>
                    </form>
                </div>
            </div>
            <div class="col-md-12" ref="historySection">
                <div class="card p-3 mt-3">
                    <h5 class="mb-3">Tracking times</h5>
                    <!-- Formulario para agregar historial -->
                    <form class="row g-2 mb-3" @submit.prevent="addHistory">
                        <div class="col-md-4">
                            <label class="form-label-compact">Start</label>
                            <input type="datetime-local" class="form-control form-control-sm" v-model="historyForm.start" required>
                        </div>
                        <div class="col-md-4">
                            <label class="form-label-compact">End</label>
                            <input type="datetime-local" class="form-control form-control-sm" v-model="historyForm.end" required>
                        </div>
                        <div class="col-md-4 d-flex align-items-end">
                            <button type="submit" class="btn btn-success btn-sm w-100" :disabled="isAddingHistory">
                                Add Entry
                            </button>
                        </div>
                        <div v-if="historyError" class="col-12">
                            <div class="alert alert-danger py-1 my-1">{{ historyError }}</div>
                        </div>
                    </form>
                    <div class="table-responsive">
                        <table class="table table-sm table-striped align-middle">
                            <thead>
                                <tr>
                                    <th>Start</th>
                                    <th>End</th>
                                    <th>Duration</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(entry, index) in form.history" :key="index">
                                    <td>{{ entry.start ? new Date(entry.start).toLocaleString() : 'N/A' }}</td>
                                    <td>{{ entry.end ? new Date(entry.end).toLocaleString() : 'N/A' }}</td>
                                    <td>
                                        <template v-if="entry.start && entry.end">
                                            {{
                                                (() => {
                                                    const ms = new Date(entry.end) - new Date(entry.start);
                                                    if (ms <= 0) return '0 min';
                                                    const totalMinutes = Math.floor(ms / 60000);
                                                    const days = Math.floor(totalMinutes / 1440);
                                                    const hours = Math.floor((totalMinutes % 1440) / 60);
                                                    const minutes = totalMinutes % 60;
                                                    let result = '';
                                                    if (days) result += days + ' days ';
                                                    if (hours) result += hours + ' hours ';
                                                    if (minutes || (!days && !hours)) result += minutes + ' minutes';
                                                    return result.trim();
                                                })()
                                            }}
                                        </template>
                                    </td>
                                    <td>
                                        <button
                                            class="btn btn-danger btn-sm"
                                            @click="deleteHistory(index)"
                                            type="button"
                                        >
                                            Delete
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
var config = require("@/config/api.json");
const API = config.api;

export default {
    name: "RepairEditEvent",
    props: {
        selectedRepair: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            user: null,
            form: {
                id: null,
                tech: "",
                jobName: "",
                po: "",
                contactName: "",
                contactNumber: "",
                unitDesc: "",
                status: 1,
                analogBoard: 0,
                issueReported: "",
                description: "",
                history: []
            },
            isUpdating: false,
            historyForm: {
                start: "",
                end: ""
            },
            isAddingHistory: false,
            historyError: ""
        };
    },
    async mounted() {
        try {
                const { auth } = await import("@/fb");
                const user = auth.currentUser;
                if (user) {
                    this.user = user;
                } else {
                    // Si no está disponible inmediatamente, esperar a onAuthStateChanged
                    const { onAuthStateChanged } = await import("firebase/auth");
                    await new Promise((resolve) => {
                        onAuthStateChanged(auth, (u) => {
                            if (u) {
                                this.user = u;
                                resolve();
                            }
                        });
                    });
                }
            } catch (e) {
                this.user = null;
            }
    },
    watch: {
        selectedRepair: {
            immediate: true,
            handler(newVal) {
                if (newVal) {
                    this.form = {
                        id: newVal.id,
                        sn: newVal.sn || "",
                        tech: newVal.tech || "",
                        jobName: newVal.jobName || "",
                        po: newVal.po || "",
                        status: newVal.status || 1,
                        contactName: newVal.contactName || "",
                        contactNumber: newVal.contactNumber || "",
                        unitDesc: newVal.unitDesc || "",
                        analogBoard: typeof newVal.analogBoard === "number" ? newVal.analogBoard : 0,
                        issueReported: newVal.issueReported || "",
                        description: newVal.description || "",
                        history: newVal.history || []
                    };
                }
            }
        }
    },
    methods: {
        async deleteHistory(index) {
            // Obtener el id del historial a borrar
            const entry = this.form.history[index];
            if (!entry || !entry.id) return;
            try {
                const res = await axios.delete(`${API}/delete-repairshistory`, { params: { id: entry.id } });
                if (res.data && res.data.status === "success") {
                    await this.fetchRepairHistory();
                     this.$emit("repairUpdated");
                    this.notify && this.notify("success", "Entry deleted from history");
                } else {
                    this.notify && this.notify("error", res.data && res.data.message ? res.data.message : "Error deleting entry");
                }
            } catch (e) {
                this.notify && this.notify("error", "Error deleting entry");
            }
        },
        async addHistory() {
            this.historyError = "";
            if (!this.historyForm.start || !this.historyForm.end) {
                this.historyError = "Both start and end dates are required.";
                return;
            }
            if (this.historyForm.start > this.historyForm.end) {
                this.historyError = "Start date cannot be after end date.";
                return;
            }
            this.isAddingHistory = true;
            try {
                const payload = {
                    repairId: this.form.id,
                    start: this.historyForm.start,
                    end: this.historyForm.end
                };
                const res = await axios.post(`${API}/create-repairshistory`, payload);
                if (res.data && res.data.status === "success") {
                    this.callLog(this.user.email, 'create', 'repairs', `Added history entry for repair ID ${this.form.id} SN: ${this.form.sn}`);
                    // Recargar historial desde el backend
                    await this.fetchRepairHistory();
                    this.historyForm.start = "";
                    this.historyForm.end = "";
                     this.$emit("repairUpdated");
                    this.notify && this.notify("success", "Entry added to history");
                } else {
                    this.historyError = res.data && res.data.message ? res.data.message : "Error adding entry";
                }
            } catch (e) {
                this.historyError = "Error adding entry";
            } finally {
                this.isAddingHistory = false;
            }
        },

        async fetchRepairHistory() {
            if (!this.form.id) return;
            try {
                const res = await axios.get(`${API}/get-repairshistory`, { params: { repairId: this.form.id } });
                if (res.data && res.data.status === "success" && Array.isArray(res.data.history)) {
                    this.form.history = res.data.history;
                }
            } catch (e) {
                // No notificación, solo silencio
            }
        },
        async submitUpdate() {
            this.isUpdating = true;
            try {
                const payload = {
                    id: this.form.id,
                    tech: this.form.tech,
                    jobName: this.form.jobName,
                    po: this.form.po,
                    contactName: this.form.contactName,
                    contactNumber: this.form.contactNumber,
                    unitDesc: this.form.unitDesc,
                    analogBoard: this.form.analogBoard,
                    issueReported: this.form.issueReported,
                    description: this.form.description,
                    status: this.form.status
                };
                const res = await axios.post(`${API}/update-repair`, payload);
                if (res.data && res.data.status === "success") {
                    this.callLog(this.user.email, 'update', 'repairs', `Updated repair with ID ${this.form.id} SN: ${this.form.sn}`);
                    this.$emit("repairUpdated");
                    this.notify("success", "Repair updated successfully");
                } else {
                    this.notify("error", res.data && res.data.message ? res.data.message : "Error updating repair");
                }
            } catch (e) {
                this.notify("error", "Error updating repair");
            } finally {
                this.isUpdating = false;
            }
        },
    }
};
</script>
